import {Component} from '@angular/core';
import {RouterModule} from '@angular/router';
import {WaButtonDirective} from 'angular-awesome';
import {WaTextDirective} from 'angular-awesome';
import {WaDetailsDirective} from 'angular-awesome';
import {MarkdownComponent} from 'ngx-markdown';
@Component({
	selector:'jwebmp-pcomp-ag-scatter-chart',
	templateUrl:'./AgScatterChartPluginCompPage.html',
	styles: [],
	styleUrls:['./AgScatterChartPluginCompPage.scss'
],
	viewProviders:[],
	animations:[],
	providers:[],
	schemas:[],
	preserveWhitespaces:true,
	host:{},
	imports:[
		RouterModule,
		WaButtonDirective,
		WaTextDirective,
		WaDetailsDirective,
		MarkdownComponent,
],
	standalone:true
})
export class AgScatterChartPluginCompPage
{
	mdContent_755 = `\`\`\`java
import com.jwebmp.plugins.agcharts.AgScatterChart;
\`\`\``;
}
